module.exports = __webpack_public_path__ + "static/media/tick.bff0d719.svg";